import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import DropdownSelect from "../../../components/dropdown/Dropdown";
import Table from "../../../components/table/Table";
import CPASMemberServices from "../../../services/axiosServices/apiServices/CPASMemberServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import { Component } from "react-image-crop";
import moment from "moment";
import DropdownAction from "../../../components/dropdown/DropdownAction";
import ActionContainer from "../../../components/UIComponent/ActionTableComponent/actionContainer";
import { encryptAES } from "../../../utils/Encryption";
import { CommonSuccessMessages } from "../../../utils/Messages";
import { getAuditContext } from "../../../utils/audit/AuthenticationLibrary";

export default class CPASApplication extends Component {
  constructor(props) {

    super(props);
    this.CPASMemberServices = new CPASMemberServices();
    this.swalServices = new SwalServices();
    this.state = {
      route: null,
      roleId: 0,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        statusId: 0,
        name: "",
        email: "",
        applicationTierId: 0,
        dateFrom: null,
        dateTo: null
      },
      applicationTierList: [],
      cpasMemberList: [],
      searchByName: "",
      searchByEmailAddress: "",
      actionDropdown: ['Update','Delete'],
      statusList: [],
      cpasMemberid: 0
    };
  }

  GetAllDropDownsForCPASMember = () => {

    this.CPASMemberServices.GetAllDropDownsForCPASMember().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        var status = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "Status");
        status.map(function (item) { delete item["dropdownName"]; return item; });
        this.setState({ statusList: status });

        let TierList = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "Tier");
        TierList.map(function (item) { delete item["dropdownName"]; return item; });
        // TierList = TierList.map((p) => ({ value: p.id, label: p.name }));
        this.setState({ applicationTierList: TierList });
      }
    });
    this.GetAllCPASMembersList();
  }


  componentDidMount() {
    const audit = getAuditContext()

    this.GetAllDropDownsForCPASMember();
    this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId });
  }

  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination });
    this.GetAllCPASMembersList();
  };


  GetAllCPASMembersList = (pagination = this.state.pagination) => {

    this.setState({ isLoading: true });

    const audit = getAuditContext()

    const roleId = audit && audit.adminUserId ? Number(audit.adminUserId) : 0;
    const requestData = {
      ...pagination,
      roleId: roleId
    }
    this.CPASMemberServices.GetAllCPASMembersList(requestData).then((response) => {

      if (response.statusCode === 200 && response.responseItem != null) {
        let data = response.responseItem.responseContent.itemList;
        data.map((x) => {
          x.submissionDate = x.submissionDate ? moment(x.submissionDate).format("DD MMM yyyy") : "-";
          x.interviewDate = x.interviewDate ? moment(x.interviewDate).format("DD MMM yyyy") : "-";

          return x;
        });
        this.setState({ cpasMemberList: data });

        this.setState({ totalResultes: response.responseItem.responseContent.totalCount });
      }
      else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    })
  }

  actions = (element, index, value) => {

    return element !== "cpasMemberid" ? null : (
      <>
        <ActionContainer>
          <DropdownAction
            key={index}
            index={index}
            value={value}
            options={this.state.actionDropdown}
            align="right"
            onOptionClick={this.actionClick.bind(this)}
          />
        </ActionContainer>
      </>
    );
  };

  actionClick = (index, value, option) => {
    if (!value || value <= 0) return;

    if (option === "Update") {
      this.updateCPASMember(value);
    }

    if (option === "Delete") {
      this.deleteCPASMember(value);
    }
  };
  deleteCPASMember = (value) => {
    const audit = getAuditContext();

    let request = {
      id: value,
      deletedBy: audit.adminUserId,
      appId: audit.appId
    };

    this.swalServices.Confirm(
      CommonSuccessMessages.Confirm_Question.replace("{0}", "Member"),
      CommonSuccessMessages.Confirm_Delete.replace("{0}", "Member"),
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text
    ).then((response) => {
      if (response) {
        this.CPASMemberServices.deleteCPASMember(request).then((response) => {
          if (response.statusCode === 200) {
            this.swalServices.Success("Deleted");
            this.GetAllCPASMembersList();
          } else {
            this.swalServices.Error(response.message);
          }

          this.setState({ isLoading: false });
        });
      }
    });
  };

  updateCPASMember = (value) => {
    if (value && value > 0) {
      this.setState({ route: '/ViewCPASApplication/CPASMemberId?=' + encryptAES(value) });
    }
  }

  searchByName = (value, identity) => {
    let detail = this.state.pagination;
    if (identity === "Name") {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.name = value;
      this.setState({ pagination: { ...detail } });
    }
    this.GetAllCPASMembersList();
  }
  searchByEmail = (value, identity) => {
    let detail = this.state.pagination;
    if (identity === "Email") {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.email = value;
      this.setState({ pagination: { ...detail } });
    }
    this.GetAllCPASMembersList();
  }


  setTierFilter = (id) => {

    let detail = this.state.pagination;
    detail.pageNo = 1;
    detail.applicationTierId = id;
    this.setState({ pagination: { ...detail } }, () => {
      this.GetAllCPASMembersList();
    });
  }

  setFilterParameters = (id) => {

    let detail = this.state.pagination;
    detail.pageNo = 1;
    detail.statusId = id;
    this.setState({ pagination: { ...detail } }, () => {
      this.GetAllCPASMembersList();
    });
  }


  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let detail = this.state.pagination;
    detail[name] = value;
    this.setState({ pagination: detail });
  }
  searchBySubmissionDate = () => {
    this.GetAllDropDownsForCPASMember(this.state.pagination);
  }
  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className="main-body-section">
        <div className="flex">
          <div className="relative flex flex-col flex-1 "></div>
        </div>
        <main className="pb-10">
          <div className="custom-card shadow-lg mb-10 bg-white">
            <div className="filter-info grid grid-cols-12 gap-6">
              <div className="filter-types 2xl:col-span-3 lg:col-span-4 col-span-12">
                <h2 className="input-title mb-3">
                  Search by Name
                </h2>
                <input
                  id="default"
                  className="form-input rounded-none w-full shadow-red py-3 text-lg"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => this.searchByName(e.target.value, 'Name')}
                />

              </div>
              <div className="filter-types 2xl:col-span-3 lg:col-span-4 col-span-12">
                <h2 className="input-title mb-3">
                  Search by Email
                </h2>
                <input
                  id="default"
                  className="form-input rounded-none w-full shadow-red py-3 text-lg"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => this.searchByEmail(e.target.value, 'Email')}
                />
              </div>

              <div className="filter-types 2xl:col-span-3 lg:col-span-4 col-span-12">
                <h2 className="input-title mb-3">
                  Type of Application
                </h2>
                <DropdownSelect
                  drpIdentity={"Tier"}
                  optionArray={this.state.applicationTierList}
                  setFilterParameters={this.setTierFilter.bind(this)}
                  value={this.state.pagination.applicationTierId}
                />
              </div>



              <div className="2xl:col-span-5 lg:col-span-6 col-span-12 pr-2">
                <h2 className="input-title mb-3">
                  Submission Date
                </h2>
                <div className="grid grid-cols-12 gap-6 items-center w-full">
                  <div className="2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                    <input
                      id="default"
                      name="dateFrom"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      type="date"
                      value={this.state.pagination.dateFrom}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="2xl:col-span-1 lg:col-span-1 col-span-12 w-full text-center">
                    <h2 className="text-xl theme-color">To</h2>
                  </div>
                  <div className=" 2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                    <input
                      id="default"
                      name="dateTo"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      type="date"
                      value={this.state.pagination.dateTo}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>

                </div>
              </div>

              <div className="filter-types 2xl:col-span-3 lg:col-span-4 col-span-12">
                <h2 className="input-title mb-3">
                  Status
                </h2>
                <DropdownSelect
                  drpIdentity={"statusId"}
                  optionArray={this.state.statusList}
                  setFilterParameters={this.setFilterParameters.bind(this)}
                  value={this.state.pagination.statusId} />
              </div>

              <div className="grid grid-flow-col sm:auto-cols-max justify-end sm:justify-start gap-3 mt-8 ml-0 2xl:ml-16">

                <button
                  className="btn btn-blue text-white font-semibold"
                  onClick={() => this.searchBySubmissionDate()}
                >
                  <span className="text-xl text-white font-semibold tracking-normal">
                    Search
                  </span>
                </button>

              </div>
            </div>
          </div>

          <div className="relative">
            <div>
              <div className="">
                <Table
                  columns={[
                    { name: "name", title: "Name" },
                    { name: "email", title: "Email" },
                    { name: "applicationTierId", title: "Type of Application" },
                    { name: "submissionDate", title: "Submission Date" },
                    { name: "interviewDate", title: "Interview Date" },
                    { name: "statusName", title: "Status" },
                    { name: "cpasMemberid", title: "Action" },
                  ]}
                  rows={this.state.cpasMemberList}

                  isLoading={this.state.isLoading}
                  sortingColumns={["companyName", "statusName"]}
                  pagination={this.state.pagination}
                  totalResultes={this.state.totalResultes}
                  totalCount={this.state.totalResultes}
                  setPagination={this.setPagination.bind(this)}

                  customScope={[
                    {
                      column: "cpasMemberid",
                      renderTableData: this.actions.bind(this),
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        </main>
      </div>

    );
  }
}